import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 16"
  >
    <path d="M-2-4h24v24H-2z" fill="transparent" />
    <path d="M18 0c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0zm0 2H2v12h16V2zM5.64 5v6H4.49V6.5l-.9.66-.58-.89L4.77 5h.87zm2.92.2c.69-.33 1.48-.2 1.95.03.86.44.91 1.24.91 1.48 0 .64-.31 1.26-.92 1.86-.25.25-.72.71-1.4 1.39l.03.05h2.37V11H7.61V9.98l.21-.21.388-.388.18-.18.33-.332c.468-.469.806-.812 1.022-1.04.4-.42.54-.69.54-1.06 0-.4-.31-.72-.81-.72-.52 0-.8.39-.9.72l-1.01-.42c.01-.02.18-.76 1-1.15zm6.38-.2c1.09 0 1.54.64 1.62.75.33.5.28 1.16.02 1.57-.15.22-.32.38-.52.48v.07c.28.11.51.28.68.52.37.52.33 1.27.01 1.76-.08.13-.56.85-1.76.85h-.07c-.315-.004-1.582-.103-1.98-1.51l1.03-.41c.03.1.19.86 1.02.86.41 0 .89-.28.89-.77 0-.55-.48-.79-1.04-.79h-.5v-1h.46c.33 0 .88-.14.88-.72 0-.39-.31-.65-.75-.65-.5 0-.74.32-.85.64l-.99-.41C13.2 5.9 13.68 5 14.94 5z" fill="currentColor" />
  </svg>
))``;
